import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
// import requestOrganizationById from './graphql';

export default function viewUsersHOC(ViewUsersPage) {
  class WrappedComponent extends Component {
    static propTypes = {
      auth: PropTypes.shape({
        jwtToken: PropTypes.string.isRequired,
        expiration: PropTypes.number.isRequired,
        organizationId: PropTypes.string.isRequired,
        role: PropTypes.string.isRequired,
      }).isRequired,

      users: PropTypes.array.isRequired,
      refreshUsers: PropTypes.func.isRequired,
      loading: PropTypes.bool.isRequired,
      organizationsStatus: PropTypes.string.isRequired,
      orgName: PropTypes.string.isRequired,
      orgCage: PropTypes.string.isRequired,
    };

    static initialState = {
      errors: [],
      isLoading: false,
    };

    state = WrappedComponent.initialState;

    render() {
      const { isLoading } = this.state;
      const {
        auth,
        users,
        refreshUsers,
        loading,
        orgName,
        orgCage,
        organizationsStatus,
      } = this.props;
      const pageProps = {
        refreshUsers,
        organizationsStatus,
        auth,
        users,
        orgName,
        orgCage,
        loading,
        isLoading,
        viewNewUserForm: this.state.viewNewUserForm,
      };
      return <ViewUsersPage {...pageProps} />;
    }
  }

  return withRouter(WrappedComponent);
}



// WEBPACK FOOTER //
// ./src/components/ViewUsers/ViewUsersHOC.jsx